import React from 'react';
import PropTypes from 'prop-types';
import { Box, Anchor, Select, CheckBox } from 'wt-ui';
import { Descend, Ascend, Filter } from 'grommet-icons';
import { Trans } from 'react-i18next';

class Option extends React.PureComponent {
  render() {
    const { value, selected } = this.props;
    return (
      <Box background="transparent" direction="row" gap="small" align="center" pad="small">
        <CheckBox tabIndex="-1" background="green" checked={selected} onChange={() => true} />
        <Trans>{value}</Trans>
      </Box>
    );
  }
}
Option.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

const FilterComponent = ({ options, selected, onChange }) => (
  <Select
    dropAlign={{ top: 'bottom', left: 'left' }}
    plain
    icon={false}
    multiple
    closeOnChange={false}
    placeholder="select an option..."
    valueLabel={
      <Anchor>
        <Filter size="small" />
        <Trans>Filter</Trans>
      </Anchor>
    }
    selected={selected}
    options={options}
    dropHeight="medium"
    onChange={({ selected: nextSelected }) => {
      onChange(nextSelected);
    }}
  >
    {(option, index) => <Option value={option} selected={selected.indexOf(index) !== -1} />}
  </Select>
);
FilterComponent.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

const AssetClassHeader = ({ order, selected, groups, dispatch }) => (
  <Box background="transparent" justify="start" align="center" direction="row" gap="medium">
    <FilterComponent
      selected={selected}
      options={groups}
      onChange={(nextSelected) => {
        // todo: debounce dispatch?
        dispatch({ type: 'setSelected', value: nextSelected });
      }}
    />
    <Anchor
      href="#"
      onClick={(e) => {
        e.preventDefault();
        dispatch({ type: 'setOrder' });
      }}
    >
      {(() => {
        switch (order) {
          case 'asc':
            return <Ascend size="small" />;
          case 'desc':
            return <Descend size="small" />;
          default:
            return '';
        }
      })()}
      <Trans>Sort</Trans>
    </Anchor>
  </Box>
);
AssetClassHeader.propTypes = {
  order: PropTypes.string.isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  groups: PropTypes.arrayOf(PropTypes.string).isRequired,
  dispatch: PropTypes.func.isRequired,
};
export default AssetClassHeader;
